import React from 'react';
import { useUser } from '../context/UserContext';
import { useAdminData } from '../context/AdminDataContext';
import AdminDataStatus from './AdminDataStatus';

const AdminLayout = ({ children }) => {
  const { userData } = useUser();
  const { loading, errors, cacheHealth } = useAdminData();
  
  // Only show for admin users
  const isAdmin = userData?.role && 
    ['assistant', 'parishAdmin', 'globalAdmin', 'developer'].includes(userData.role);

  return (
    <>
      {children}
      {isAdmin && (
        <AdminDataStatus 
          cacheHealth={cacheHealth}
          loading={loading}
          errors={errors}
          showDetails={false} // Can be toggled for debugging
        />
      )}
    </>
  );
};

export default AdminLayout;
